import { InputText } from "primereact/inputtext";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { handleEncryptData } from "../../../services/EncryptionService";
import { handleDecryptData } from "../../../services/DecryptionService";
import { getSocket, SOCKET_ENDPOINTS } from "../../../services/Socket";
import moment from "moment";

const SupportChat = () => {
    const [message, setMessage] = useState("");
    // const [ticketId, setTicketId] = useState('');
    const [messagesList, setMessagesList] = useState([]);
    const userId = localStorage.getItem("userId");
    const newSocket = getSocket();

    const subjectValue = localStorage.getItem("subjectValue");
    const subjectName = localStorage.getItem("subjectName");
    const chatTicketId = localStorage.getItem("chatTicketId");
    const ticketId = localStorage.getItem("ticketId");

    const location = useLocation();
    const { chatTicketState } = location?.state || {};

    //Getting detail chat list of tickets card
    useEffect(() => {
        if (chatTicketState || chatTicketId) {
            const messageData = {
                ticketId: chatTicketId,
                isAdmin: false,
            };

            console.log("messageData chatTicketId", messageData);
            const encryptData = handleEncryptData(messageData);
            newSocket.emit(SOCKET_ENDPOINTS.TICKET_CHAT, JSON.stringify(encryptData), (response) => {
                const decryptedData = handleDecryptData(response?.cipher);
                setMessagesList(decryptedData);
            });
        }
    }, [chatTicketState, chatTicketId]);

    // Attach the listener only once in useEffect
    useEffect(() => {
        if (newSocket) {
            newSocket.on(SOCKET_ENDPOINTS.NEW_SUPPORT_MESSAGE, (response) => {
                console.log("response Listener:", response);
                const decryptedData = handleDecryptData(response?.cipher);
                const chatArray = Array.isArray(decryptedData?.data?.chat) ? decryptedData.data.chat : [decryptedData.data.chat]; // Wrap in an array if it's not already

                console.log("chatArray", chatArray);
                setMessagesList((prev) => ({
                    data: {
                        chat: [...(prev?.data?.chat || []), ...chatArray],
                    },
                }));
            });
        }
    }, [newSocket]);

    const sendMessage = async () => {
        if (newSocket) {
            if (!messagesList?.data?.chat?.length) {
                console.log("1st Message");
                const messageData = {
                    userId: userId,
                    subject: subjectName,
                    subjectId: subjectValue,
                    text: message,
                };
                const encryptData = handleEncryptData(messageData);

                if (message) {
                    newSocket.emit("newTicket", JSON.stringify(encryptData), (response) => {
                        const decryptedData = handleDecryptData(response?.cipher);

                        if (decryptedData?.data?._id) {
                            setMessagesList(decryptedData);
                            // setTicketId(decryptedData?.data?._id);

                            const chatMessageData = {
                                ticketId: decryptedData?.data?._id,
                                isAdmin: false,
                            };

                            localStorage.setItem("ticketId", decryptedData?.data?._id);
                            const chatEncryptData = handleEncryptData(chatMessageData);

                            newSocket.emit(SOCKET_ENDPOINTS.TICKET_CHAT, JSON.stringify(chatEncryptData), (response) => {
                                const decryptedData2 = handleDecryptData(response?.cipher);
                                setMessagesList(decryptedData2);
                            });
                        } else {
                            console.error("newTicket did not return a valid _id");
                        }
                    });
                } else {
                    console.error("Socket is not available for emitting events.");
                }
                setMessage("");
            } else {
                console.log("2nd Message");
                const messageData = {
                    ticketId: chatTicketId ? chatTicketId : ticketId,
                    text: message,
                    attachments: [],
                    isAdmin: false,
                    sendBy: userId,
                };

                console.log("messageData 2nd message", messageData);
                const encryptData = handleEncryptData(messageData);

                if (message) {
                    newSocket.emit(SOCKET_ENDPOINTS.NEW_SUPPORT_MESSAGE, JSON.stringify(encryptData), (response) => {
                        console.log("Emit Response:", response);
                    });
                } else {
                    console.error("Socket is not available for emitting events.");
                }
                setMessage("");
            }
        }
    };

    return (
        <div className="mx-auto border-200 border-3 border-round chat-section">
            <div className="chat-container w-full h-full">
                <div className="chat-header p-3 surface-card border-round w-full">
                    <h4 className="mb-0">Support</h4>
                </div>
                <div className="py-8" style={{ maxHeight: "700px", overflowY: "auto", paddingRight: "10px" }}>
                    {messagesList?.data?.chat?.map((item, index) => (
                        <div
                            key={index}
                            className={item?.isAdmin ? "ml-2" : "mr-2"}
                            style={{
                                textAlign: item?.isAdmin ? "left" : "right",
                                margin: "10px 0",
                            }}
                        >
                            <span
                                style={{
                                    display: "inline-block",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    backgroundColor: item?.isAdmin ? "#f1f1f1" : "#007bff",
                                    color: item?.isAdmin ? "#000" : "#fff",
                                    maxWidth: "70%",
                                    wordWrap: "break-word",
                                    boxShadow: item?.isAdmin ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "0px 4px 12px rgba(0, 0, 0, 0.15)",
                                }}
                            >
                                {item?.text}
                                <div
                                    style={{
                                        fontSize: "12px",
                                        marginTop: "5px",
                                        color: "#888",
                                        textAlign: item?.isAdmin ? "right" : "left",
                                        color: item?.isAdmin ? "gray" : "white",
                                    }}
                                >
                                    {moment(item?.createdAt).fromNow()}
                                </div>
                            </span>
                        </div>
                    ))}
                </div>

                <div className="flex align-items-center surface-300 chat-input w-full p-3">
                    <div className="flex align-items-center w-full chat-inputfield">
                        <InputText className="block w-full" placeholder="Type a Message" value={message} onChange={(e) => setMessage(e.target.value)} />
                        <i className="pi pi-link text-xl cursor-pointer"></i>
                    </div>
                    <div className="send-btn cursor-pointer" onClick={sendMessage}>
                        <i className="pi pi-send ml-3 text-xl"></i>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportChat;
